var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.175,
    height: 21.914,
    viewBox: "0 0 25.175 21.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(-24.168 -416.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-email-2856578",
    transform: "translate(-58.977 417.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M186.71,47.27l5.574,4.469a1.129,1.129,0,0,0,1.356,0l5.574-4.469V38.03h-12.5Zm2.26-.954a.5.5,0,0,1-.5-.5.54.54,0,0,1,.5-.5h4.62a.54.54,0,0,1,.5.5.5.5,0,0,1-.5.5Zm0-2.662a.54.54,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7.985a.474.474,0,0,1,.5.5.5.5,0,0,1-.5.5Zm0-2.712a.5.5,0,0,1-.5-.5.54.54,0,0,1,.5-.5h7.985a.5.5,0,0,1,.5.5.474.474,0,0,1-.5.5Z",
    transform: "translate(-97.106 -36.887)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M85.738,232.13v11.9a.665.665,0,0,0,.653.653h18.933a.665.665,0,0,0,.653-.653v-11.9l-8.839,7.031a1.919,1.919,0,0,1-2.561,0Z",
    transform: "translate(0 -223.555)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M539.51,149.51v4.168l2.561-2.059Z",
    transform: "translate(-436.396 -144.098)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M327.05.139h1.758l-.2-.2a.94.94,0,0,0-1.306,0Z",
    transform: "translate(-232.072 0)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M93.605,151.619l2.561,2.059V149.51Z",
    transform: "translate(-7.566 -144.098)",
    fill: "#ddd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_6",
    "data-name": "Linha 6",
    y1: 8,
    x2: 9,
    transform: "translate(24.5 430.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_7",
    "data-name": "Linha 7",
    x1: 8.5,
    y1: 8,
    transform: "translate(40.5 430.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadNotificationIcon);
export default __webpack_public_path__ + "static/media/read_notification_icon.aca83506437cd4757c164ad8526d39c3.svg";
export { ForwardRef as ReactComponent };